export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6148.d0fe6297.jpg";